const LIFE_INTERVIEW_SECTIONS = [
  {
    title: 'Roots & early years',
    introduction: 'Begin wherever the memories feel clearest. There is no need to tell everything at once.',
    questions: [
      'Where did your story begin, and what do you remember most about the place you grew up?',
      'Who made you feel safe, encouraged, or understood when you were young?',
      'What family tradition, saying, meal, or small ritual has stayed with you?',
    ],
  },
  {
    title: 'Finding your way',
    introduction: 'A life is shaped by the people, choices, and unexpected turns along the way.',
    questions: [
      'What was a turning point that changed the direction of your life?',
      'Which friendship or relationship taught you something you still carry?',
      'What challenge are you proud of facing, and what helped you through it?',
    ],
  },
  {
    title: 'What mattered most',
    introduction: 'Think about the values and ordinary joys that made a life feel like your own.',
    questions: [
      'What work, craft, or contribution gave you a sense of purpose?',
      'What simple moments have brought you the greatest happiness?',
      'What belief or principle has guided the choices you are glad you made?',
    ],
  },
  {
    title: 'Words for the next generation',
    introduction: 'Leave a few thoughts for the people who will remember and learn from your story.',
    questions: [
      'What do you hope your loved ones remember about the way you lived?',
      'What advice would you offer someone beginning a chapter you have already lived?',
      'Is there a story, person, or lesson you would like your family to keep close?',
    ],
  },
];

export default LIFE_INTERVIEW_SECTIONS;